import React from 'react';
import ToolsControl from './ToolsControl';
import { ApiToolResponse } from '../../interfaces';
import { Row } from 'react-bootstrap';


// Create the list component with TypeScript
const ToolsControlList: React.FC<ApiToolResponse> = ({ result }) => {
  return (
    <Row className="g-4 mt-4">
      {result.map((tool, index) => (
        <ToolsControl
          key={index}
          id={tool.id}
          url={tool.url}
          image={tool.image}
          name={tool.name}
          isIntern={tool.isIntern}
          description={tool.description}
        />
      ))}
    </Row>
  );
};

export default ToolsControlList;
